import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Copy } from '@honda-canada/design-system-react';
import { compiler } from 'markdown-to-jsx';
import themeStyles from './TrimOverview.styles';
const StyledTitle = themeStyles.apply(Copy, 'StyledTitle');
const TrimDetails = ({ transmissionName, modelYear, modelName, trimName, align, size = 'regular', }) => {
    const trimDetails = Array.of(modelYear, modelName, trimName, transmissionName);
    const title = compiler(trimDetails.filter(Boolean).join(' '));
    return (_jsx(StyledTitle, { as: "h2", "data-testid": "cy-trimoverview-title", size: size, justifyContent: align, children: title }));
};
export default TrimDetails;
